<template>
    <div class="apprentice-simple-card remove-bottom-card-margin group-pair-logs-overview">
        <div class="group-pair-logs-header">
            <h3 class="title">{{groupPairGroupIn.subject }}</h3>
            
            <div class="motivation">
                <div class="heading">{{$t('paper.motivation')}}</div>
                <div class="description">
                    {{ groupPairGroupIn.explanation }}
                </div>
            </div>
            
            <div class="feedback">
                <div class="heading">Feedback</div>
                <div class="description">
                    {{ groupPairGroupIn.feedback }}
                </div>
            </div>
        </div>
       
        <design-2021-group-pair-log-component
            :activities-in="activities">
        </design-2021-group-pair-log-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-paper-group-pair-tool-history-component",
    props: {
        groupPairGroupIn: Object
    },
    data() {
        return {
            activities: this.groupPairGroupIn.activities,
        }
    }
}
</script>


<style scoped lang="scss">
    .title,
    .motivation {
        margin-bottom: $grid-gutter-width;
    }
    
    .heading {
        font-weight: $font-weight-medium;
        font-size: 1.125rem;
    }
    
    .description {
        border-radius: $border-radius-content;
        background-color: $border-color;
        color: $text-color;
        min-height: 100px;
        padding: map-get($grid-gutter-spacing, 'fifteen');
    }
    
    
    
    .feedback {
        margin-bottom: map-get($grid-gutter-spacing, 'sixty');
    }
</style>
